import { Injectable } from '@angular/core';
import { Step, StepState } from '../components/molecules/step/step.component';
import { Router } from '@angular/router';

export enum StepId {
  Services = 0 ,
  SubstepCarDetails ,
  SubstepServices,
  Workshops,
  DateAndTime,
  SubstepDateAndTime,
  SubstepPersonalData,
  SubstepConfirmation,
  PersonalData,
  CarDetails
}

@Injectable({
  providedIn: 'root'
})
export class StepperService {
  private currentStepIndex = 0;
  private currentSubstepIndex = 0;
  private steps: Step[] = [
    { id: StepId.Services, title: 'Servicios ', state: StepState.Active, route: '', substeps: [
        { id: StepId.SubstepCarDetails, title: 'Datos del auto', state: StepState.Idle, route: ''},
        { id: StepId.SubstepServices, title: 'Servicios', state: StepState.Idle, route: 'services'}
      ] 
    },
    { id: StepId.Workshops, title: 'Concesionario ', state: StepState.Idle, route: 'concesionario' },
    { id: StepId.DateAndTime, title: 'Elegir turno ', state: StepState.Idle, route: 'fecha-y-hora', substeps:[
      {id: StepId.SubstepDateAndTime, title: 'Elegir turno ', state: StepState.Idle, route: 'fecha-y-hora'},
      { id: StepId.SubstepPersonalData, title: 'Datos personales', state: StepState.Idle, route: 'datos-personales' },
      { id: StepId.SubstepConfirmation, title: 'Confirmá el turno', state: StepState.Idle, route: 'revision-turno' }
    ]},
    // { id: StepId.CarDetails, title: '', state: StepState.Idle, route: ''},
    // { id: StepId.SubstepCarDetails, title: 'Datos del vehículo ', state: StepState.Idle, route: 'datos-vehiculo' },
    // { id: StepId.PersonalData, title: 'Datos personales', state: StepState.Idle, route: 'datos-personales' },
    // { id: StepId.Confirmation, title: 'Confirmá el turno', state: StepState.Idle, route: 'revision-turno' },
  ];

  constructor(private router: Router) {
  }

  getSteps(): Step[] {
    return this.steps;
  }

  nextStep(): void {
    const step = this.steps[this.currentStepIndex];

    if (step.substeps && step.substeps.length > 0 && this.currentSubstepIndex < step.substeps.length) {
      const currentSubstep = step.substeps[this.currentSubstepIndex];
      currentSubstep.state = StepState.Completed;

      this.currentSubstepIndex++;
      if (this.currentSubstepIndex < step.substeps.length) {
        step.substeps[this.currentSubstepIndex].state = StepState.Active;
        this.router.navigate([step.substeps[this.currentSubstepIndex].route!]);
        return;
      }
    }
    step.state = StepState.Completed;
    this.currentStepIndex++;
    this.currentSubstepIndex = 0;

    if (this.currentStepIndex < this.steps.length) {
      const nextStep = this.steps[this.currentStepIndex];
      nextStep.state = StepState.Active;

      if (nextStep.substeps && nextStep.substeps.length > 0) {
        nextStep.substeps[0].state = StepState.Active;
        this.router.navigate([nextStep.substeps[0].route!]);
      } else {
        this.router.navigate([nextStep.route!]);
      }
    }
  }

  previousStep(): void {
    const step = this.steps[this.currentStepIndex];
    
    if (step.substeps && this.currentSubstepIndex > 0) {
      step.substeps[this.currentSubstepIndex].state = StepState.Idle;
      this.currentSubstepIndex--;
      step.substeps[this.currentSubstepIndex].state = StepState.Active;
      this.router.navigate([step.substeps[this.currentSubstepIndex].route!]);
      return;
    }

    step.state = StepState.Idle;
    this.currentStepIndex--;
    this.currentSubstepIndex = 0;

    if (this.currentStepIndex >= 0) {
      const prevStep = this.steps[this.currentStepIndex];
      prevStep.state = StepState.Active;

      if (prevStep.substeps && prevStep.substeps.length > 0) {
        this.currentSubstepIndex = prevStep.substeps.length - 1;
        prevStep.substeps[this.currentSubstepIndex].state = StepState.Active;
        this.router.navigate([prevStep.substeps[this.currentSubstepIndex].route!]);
      } else {
        this.router.navigate([prevStep.route!]);
      }
    }
  }

  getCurrentSubstep(): Step | undefined {
    const step = this.steps[this.currentStepIndex];
    if (step.substeps && step.substeps.length > 0) {
      return step.substeps[this.currentSubstepIndex];
    }
    return undefined;
  }

  goToStep(stepId: number): void {
    let stepFound = false;

    this.steps.forEach(step => {
      if (step.id < stepId) {
        step.state = StepState.Completed;
      } else if (step.id === stepId) {
        step.state = StepState.Active;
        stepFound = true;
      } else {
        step.state = StepState.Idle;
      }
    });

    const stepToActivate = this.steps.find(step => step.id === stepId);
    if (stepToActivate) {
      this.router.navigate([stepToActivate.route]);
    }
  }

  isStepAccessible(stepId: StepId): boolean {
    const step = this.steps.find(s => s.id === stepId);
    return step ? step.state === StepState.Completed : false;
  }

  isFirstStep(): boolean {
    const currentStep = this.getCurrentStep();
    return currentStep ? currentStep.id === StepId.SubstepCarDetails : false;
  }

  getCurrentStep(): Step | undefined {
    const location = this.router.url.split('/').pop() || '';

    for (let i = 0; i < this.steps.length; i++) {
      const currentStep = this.steps[i];
      currentStep.state = StepState.Idle;
      if (currentStep.substeps) currentStep.substeps.forEach(s => s.state = StepState.Idle);
        if(currentStep && currentStep.substeps&& currentStep.substeps.length > 0) {
          for (let j = 0; j < currentStep.substeps.length; j++) {
            const substep = currentStep.substeps[j];
            if(substep.route === location) {
            for(let k = 0; k < i; k++) this.steps[k].state = StepState.Completed;
            for(let k = 0; k < j; k++) currentStep.substeps[k].state = StepState.Completed;
            for (let k = j + 1; k < currentStep.substeps.length; k++) currentStep.substeps[k].state = StepState.Idle;

            for (let k = i + 1; k < this.steps.length; k++) {
              this.steps[k].state = StepState.Idle;
              if (this.steps[k].substeps) this.steps[k].substeps?.forEach(s => s.state = StepState.Idle);
            }
            this.currentStepIndex = i;
            this.currentSubstepIndex = j;
            currentStep.state = StepState.Active;
            currentStep.state = StepState.Active;

            return this.steps[this.currentStepIndex].substeps?.[this.currentSubstepIndex] || this.steps[this.currentStepIndex];
          }
        }
      }

      if (currentStep.route === location) {
        for (let k = 0; k < i; k++) this.steps[k].state = StepState.Completed;
        currentStep.state = StepState.Active;

        if (currentStep.substeps) currentStep.substeps.forEach(s => s.state = StepState.Idle);

        for (let k = i + 1; k < this.steps.length; k++) {
          this.steps[k].state = StepState.Idle;
          if (this.steps[k].substeps) this.steps[k].substeps?.forEach(s => s.state = StepState.Idle);
        }

        this.currentStepIndex = i;
        this.currentSubstepIndex = 0;
        return this.steps[this.currentStepIndex].substeps?.[this.currentSubstepIndex] || this.steps[this.currentStepIndex];
      }

    }
    this.steps.forEach(s => {
      s.state = StepState.Idle;
      if (s.substeps) s.substeps.forEach(ss => ss.state = StepState.Idle);
    });
    this.currentStepIndex = 0;
    this.currentSubstepIndex = 0;
    this.steps[0].state = StepState.Active;
    if (this.steps[0].substeps?.length) this.steps[0].substeps[0].state = StepState.Active;

    return this.steps[0].substeps?.[0] || this.steps[0];
  }
}